// ============================================================================
// LA COQUE VERRE des modales de travail de la Console — le voile flouté et la boîte, tels que la maquette les dessine
// pour l'assistant d'équipement et pour l'entrée au parc. Partagée à la règle de deux : deux copies du même voile
// divergeraient au premier réglage, et deux modales voisines ne se ressembleraient plus.
// ============================================================================
import type { CSSProperties } from 'react';

/** Le voile : la page reste devinée derrière, floutée. */
export const glassOverlaySt: CSSProperties = {
  position: 'fixed', inset: 0, zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center',
  padding: 24, background: 'color-mix(in srgb, var(--canvas) 68%, transparent)', backdropFilter: 'blur(14px) saturate(1.4)',
};

/** La boîte, à la largeur de son contenu : en-tête et pied fixes, le corps défile. */
export const glassBoxSt = (width: number): CSSProperties => ({
  width, maxWidth: '100%', maxHeight: 'calc(100vh - 48px)', display: 'flex', flexDirection: 'column',
  background: 'color-mix(in srgb, var(--elev, var(--paper)) 92%, transparent)', backdropFilter: 'var(--glass-blur)',
  border: '1px solid var(--ink200)', borderRadius: 'var(--r-lg)', boxShadow: '0 30px 70px -24px rgba(0,0,0,.7)', overflow: 'hidden',
});
